import React, { Component } from 'react';
import { obtenirMenu, obtenirServiceGarde } from '../../services/ICSG.service';
import { Chargement } from './Chargement';
import { Erreur } from './Erreur';
import { InformationSG } from './InformationSG';
import { Menu } from './Menu';

export class InformationsComplementaires extends Component {
    estMonte = false;

    constructor(props) {
        super(props)
        this.state = {
            message: "Chargement...",
            serviceGarde: null,
            menus: null,
            enChargementServiceGarde: true,
            enChargementMenu: true,
        }
    }

    componentDidMount() {
        this.estMonte = true;
        obtenirServiceGarde().then(reponse => {
            const serviceGarde = reponse;
            if (this.estMonte) {
                this.setState({ serviceGarde: serviceGarde, enChargementServiceGarde: false });
            }
            obtenirMenu().then(reponse => {
                const menus = reponse;
                if (this.estMonte) {
                    this.setState({ menus: menus, enChargementMenu: false });
                }
            });
        });
    }

    componentWillUnmount() {
        this.estMonte = false;
    }

    render() {
        const { enChargementServiceGarde, enChargementMenu, serviceGarde, menus } = this.state;

        if (enChargementServiceGarde || enChargementMenu) {
            return <Chargement />;
        }

        const { erreur } = serviceGarde;
        if (erreur) {
            return <Erreur serviceGarde={serviceGarde} />;
        }

        return (
            <>
                <InformationSG serviceGarde={serviceGarde} />
                <Menu menus={menus} />
            </>
        );
    }
}
